import { createI18n, type I18nOptions } from "vue-i18n"

import de from "./locales/de.json"

export const DEFAULT_LANGUAGE = "de"
export const language = localStorage.getItem("language") || DEFAULT_LANGUAGE

const options: I18nOptions = {
  legacy: false,
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: language,
  messages: { de },
  globalInjection: true,
  warnHtmlMessage: false,
}
// https://vue-i18n.intlify.dev/guide/advanced/typescript#global-resource-schema-type-definition
export const i18n = createI18n<false, typeof options>(options)
